import { Box, Container, Stack } from "@mui/material"
import React from "react"
import { DosageCalculator } from "../templates/use/dosage/calculator"
import { HorizontalSlantContainer } from "./horizontal-slant-container"
import { ReviewsCarosel } from "./reviews/carosel"
import { ReviewsList } from "./reviews/list"
import { Button } from "./ui"

type Props = {
    id: string
    component: 'Dosage calculator' | 'Reviews highlight' | 'All reviews'
}

export const DynamicAdditionalComponent = ({ id, component }: Props) => {

    if (component === 'Dosage calculator') return (
        <HorizontalSlantContainer key={id} id={id} autoHeight svgStyle={{ borderRadius: '40px' }}>
            <Container
                sx={{ pt: { xs: "40px", sm: "40px", md: "50px" }, pb: { xs: "30px" }, color: 'white', textAlign: 'center' }}
            >
                <DosageCalculator isSiteFramed={false} />
            </Container>
        </HorizontalSlantContainer>
    )
    else if (component === 'Reviews highlight') {
        return (
            <Stack gap={3} justifyContent={"center"} sx={{ mt: 4, mb: 8 }} alignItems={"center"}>
                {/* <Typography variant="h3">Our reviews</Typography> */}
                {/* <JudgemeCarousel /> */}
                <ReviewsCarosel featured id={id} />
                <Box sx={{ marginTop: '-90px' }}>
                    <Button size="large" to="/reviews">View more reviews</Button>
                </Box>
            </Stack>
        )
    }
    else if (component === 'All reviews') {
        return <ReviewsList allowSort id={id} />
        // return <JudgemeReviewsTab />
    }

    return <></>
}
